import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@metarouter-private/mr-mui';

export default function StatusCell({ successAt }) {
  const isSuccess = successAt !== null;

  return (
    <Chip
      label={isSuccess ? 'Success' : 'Failed'}
      color={isSuccess ? 'success' : 'error'}
      variant="soft"
      size="small"
    />
  );
}

StatusCell.propTypes = {
  successAt: PropTypes.string,
};
